let productList = {};
// Populate productList with product-info elements
document.querySelectorAll('product-info').forEach(el => {
    const dataID = el.dataset.id; // Get the data-id attribute
    productList[dataID] = el; // Store the element for later use
});
// Add event listeners to variant-change buttons
document.querySelectorAll('.change-gender').forEach(button => {
    button.addEventListener('click', function() {
        // Get the target variant-selects element's id from the button's data attribute
        const targetSelectId = this.getAttribute('data-select-id');
        const targetVariantSelect = document.getElementById(targetSelectId); // Get the target by ID
        // Remove all existing product-info elements
        document.querySelectorAll('product-info').forEach(el => {
            el.remove();
        });
        // Check if targetVariantSelect is found
        if (targetVariantSelect) {
            // Get the new product HTML from productList
            const newProduct = productList[targetSelectId]?.innerHTML; // Optional chaining to avoid errors
            if (newProduct) { // Ensure newProduct is not undefined
                let textContent = '<product-info class="product__info-container">'; // Initialize textContent
                textContent += newProduct; // Append new product info
                textContent += '</product-info>';
                targetVariantSelect.innerHTML += textContent; // Append the new HTML
				document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
            } else {
                console.error(`No product found for ID: ${targetSelectId}`);
            }
        } else {
            console.error(`No targetVariantSelect found for ID: ${targetSelectId}`);
        }
    });
});
// When color is changed..
function changeColorVariant(selectedIndex, firstVariantIndex, productHandle) {
  console.log(selectedIndex, firstVariantIndex, productHandle)
	// Get the target variant-selects element's id from the button's data attribute
	const targetSelectId = selectedIndex;
	const targetVariantSelect = document.getElementById(firstVariantIndex); // Get the target by ID
	// Remove all existing product-info elements
	document.querySelectorAll('product-info').forEach(el => {
			el.remove();
	});
	// Check if targetVariantSelect is found
	if (targetVariantSelect) {
			// Get the new product HTML from productList
			const newProduct = productList[targetSelectId]?.innerHTML; // Optional chaining to avoid errors
			if (newProduct) { // Ensure newProduct is not undefined
					let textContent = '<product-info class="product__info-container">'; // Initialize textContent
					textContent += newProduct; // Append new product info
					textContent += '</product-info>';
					targetVariantSelect.innerHTML += textContent; // Append the new HTML
					// Usage example:
					var paymentTerm = document.getElementById('payment_term');
					if (paymentTerm.childElementCount === 0) {
						fetchProductDetails(productHandle).then(data => {
							if (data) {
								paymentTerm.innerHTML = data;
								// Handle the returned data
							} else {
								console.log('No data returned');
							}
						});
					}
					// Load payment terms or other logic here
					document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
			} else {
					console.error(`No product found for ID: ${targetSelectId}`);
			}
	} else {
			console.error(`No targetVariantSelect found for ID: ${targetSelectId}`);
	}
}
function swymCallbackFn(swat){
	// your API calls go here
	document.addEventListener("swym:collections-loaded", function(){
		swat.initializeActionButtons(".swym-add-to-wishlist-view-product");
	})
}
if(!window.SwymCallbacks){
	window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymCallbackFn);
async function fetchProductDetails(productHandle) {
  try {
		const URL = window.location.pathname + "products/" + productHandle;
    // Perform the fetch operation on the specified product URL
    const response = await fetch(URL);
    // Check if the response is successful
    if (!response.ok) {
      throw new Error(`Failed to fetch product details. Status: ${response.status}`);
    }
    // Parse the JSON data from the response
    const dataText  = await response.text();
    // Parsing the HTML content using DOMParser
    const parser = new DOMParser();
    const doc = parser.parseFromString(dataText, 'text/html');
    // Extract the element with the ID 'payment-term'
    const paymentTermElement = doc.getElementById('payment_term');
    // Log or handle the extracted element as needed
    if (paymentTermElement) {
      return paymentTermElement.innerHTML; // Return the inner HTML of the element
    } else {
      return null;
    }
  } catch (error) {
    console.error('Error:', error);
    // Consider returning an error object or null, based on your application's needs
    return null;
  }
}
